import React from "react";
import styles from "./WeekdayChips.module.css";

export interface WeekdayChipsProps {
  selected: number[];
  onChange: (selected: number[]) => void;
}

const LABELS = ["S", "M", "T", "W", "T", "F", "S"];

const WeekdayChips: React.FC<WeekdayChipsProps> = ({ selected, onChange }) => {
  const toggle = (day: number) => {
    onChange(
      selected.includes(day)
        ? selected.filter((d) => d !== day)
        : [...selected, day].sort()
    );
  };

  return (
    <div className={styles.row}>
      {LABELS.map((label, day) => (
        <button
          type="button"
          key={day}
          className={`${styles.chip} ${
            selected.includes(day) ? styles.selected : ""
          }`}
          onClick={() => toggle(day)}
          aria-pressed={selected.includes(day)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default WeekdayChips;
